export default "__VITE_ASSET__a47066e1__"